// start_ai_generated
import { useState, useEffect, useRef } from 'react'
import { setNavigationBar, backToNative, setNavbar, getNativeInfo } from '@docs/common'
import { Helmet } from 'react-helmet'
import styles from './index.module.scss'
import getCategotiesList, {
  IGuide,
  IGuideComponentType,
  IGuideVideo,
  IGuideArticle,
  ContentItem,
} from 'servers/getCategotiesList'
import { parse } from 'qs'
import { useAsyncEffect } from 'ahooks'
import { Element } from 'react-scroll'
import { getMallDomain, triggerLink, getSearchCountry } from 'common/util'
import qs from 'qs'
import { DEFAULT_APP_NAME } from '../../common/constant'
import classNames from 'classnames'
import { trackCategoriesPageClick, trackCategoriesPageDuration, trackCategoriesPageView } from 'common/track'
import moment from 'moment'
import Video from 'components/Video'
import NativeVideo from 'components/NativeVideo'
import { isYouTubeVideo } from '../../utils/videoUtils'
import useAraLayout from 'common/useAraLayout'

const CategoriesList = () => {
  const [guide, setGuide] = useState<IGuide | null>(null)
  // 标题
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  const { title = '', tabs = [], banner = [] } = guide || {}

  const { uid } = parse(window.location.search.substr(1)) as { uid: string }
  useAraLayout();

  // 通过uid获取数据
  useAsyncEffect(async () => {
    const guide = await getCategotiesList({ uid })
    setGuide(guide)
  }, [])

  // 视频埋点
  const openVideoLink = (video: { id?: number; title: any; value?: string }) => {
    const locale = guide?.locale || ''

    const sub_module =
      tabs && tabs[0]?.__component === IGuideComponentType.Video
        ? 'TutorialVideo'
        : tabs && tabs[0]?.__component === IGuideComponentType.Article
        ? 'TutorialArticle'
        : ''
    trackCategoriesPageClick(video?.title, uid, locale, sub_module)
  }
  // 判断文章是solution文章 跳转路径不同
  const hasSolutionArticle = (str: string): boolean => {
    return str.includes('solution-article')
  }

  // recommend
  const hasRecommendArticle = (str: string): boolean => {
    return str.includes('recommend-article')
  }
  // guide
  const hasGuideArticle = (str: string): boolean => {
    return str.includes('tutorial-guide')
  }
  // document
  const hasDocumentArticle = (str: string): boolean => {
    return str.includes('tutorial-document')
  }

  //文章跳转埋点
  const openLink = async (article: ContentItem) => {
    const params = qs.parse(window.location.search.substr(1))
    let appName = typeof params.app === 'string' ? params.app : DEFAULT_APP_NAME
    const locale = guide?.locale || ''

    const sub_module =
      tabs && tabs[0]?.__component === IGuideComponentType.Video
        ? 'TutorialVideo'
        : tabs && tabs[0]?.__component === IGuideComponentType.Article
        ? 'TutorialArticle'
        : ''
    uid && article?.title && (await trackCategoriesPageClick(article?.title, uid, locale, sub_module))

    let country = getSearchCountry() || article?.countries?.split(',')[0] || 'us'

    const domain = 'https://' + window.location.hostname // 获取域名

    setTimeout(async () => {
      //solution文章
      if (hasSolutionArticle(article.store)) {
        if (appName === 'eufy-security' || appName === 'eufy_mega') {
          triggerLink(
            `eufysecurity://eufy/explore/web#${await getMallDomain()}/n/recommend/solution/${article.id}?app=${appName}`
          )
        }
        if (appName === 'eufy-appliances') {
          triggerLink(`eufysecurity://eufy/explore/web#${domain}/recommend/solution/${article.uid}?app=${appName}`)
        }
      }

      //recommend文章
      if (hasRecommendArticle(article.store)) {
        triggerLink(`eufysecurity://eufy/explore/web#${await getMallDomain()}/n/recommend/${article.id}`)
      }

      //guide文章
      if (hasGuideArticle(article.store)) {
        triggerLink(
          `eufysecurity://eufy/explore/web#${domain}/navigation?app=${appName}&pn=${article.pn}&country=${country}&lang=${locale}`
        )
      }

      //document文章
      if (hasDocumentArticle(article.store)) {
        triggerLink(`eufysecurity://eufy/explore/web#${domain}/detail/${article.id}?app=${appName}`)
      }
    }, 0)
  }

  // 设置导航
  useEffect(() => {
    const fun = async () => {
      const nativeInfo = await getNativeInfo().catch(e => null)
      if (!nativeInfo || !nativeInfo?.appVersion) {
        return
      }

      // 隐藏原生导航条
      setTimeout(() => {
        setNavbar({
          hideNavbar: true, // 隐藏 App 的导航条, 使用自定义的
          backOperation: 1,
          immersiveMode: false,
        })
      }, 500)
    }
    fun()
  }, [banner])
  useEffect(() => {
    setNavigationBar({
      title: title || '',
      onBack: () => {
        if ((window as any).__IS_APP__) {
          backToNative()
        } else {
          if (window.history.length > 1) {
            window.history.back()
          }
        }
      },
    })
  }, [title])

  // 页面访问埋点
  useEffect(() => {
    const locale = guide?.locale || ''
    const sub_module =
      tabs && tabs[0]?.__component === IGuideComponentType.Video
        ? 'TutorialVideo'
        : tabs && tabs[0]?.__component === IGuideComponentType.Article
        ? 'TutorialArticle'
        : ''
    uid && title && sub_module && trackCategoriesPageView(uid, title, locale, sub_module)
  }, [uid, title, guide?.locale, tabs])

  useEffect(() => {
    // 页面加载时开始计时
    const startTime = Date.now()
    const handleResize = async () => {
      let duration = Math.floor((Date.now() - startTime) / 1000) // 计算停留时长，单位为毫秒
      // 计算页面停留时长
      const locale = guide?.locale || ''
      const sub_module =
        tabs && tabs[0]?.__component === IGuideComponentType.Video
          ? 'TutorialVideo'
          : tabs && tabs[0]?.__component === IGuideComponentType.Article
          ? 'TutorialArticle'
          : ''
      // 调用埋点函数，传入停留时长
      uid && sub_module && (await trackCategoriesPageDuration(uid, locale, sub_module, duration))
    }

    window.addEventListener('pagehide', handleResize)
    // 对于不支持 pagehide 的浏览器，使用 visibilitychange 事件
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        handleResize()
      }
    })
    // 页面加载时开始计时
    window.addEventListener('beforeunload', handleResize)
    return () => {
      // 页面卸载时停止计时
      window.removeEventListener('beforeunload', handleResize)

      window.removeEventListener('pagehide', handleResize)
      document.removeEventListener('visibilitychange', handleResize)
    }
  }, [uid, tabs, guide?.locale])

  return (
    <div
      className={classNames(styles.container, { [styles.containerTop]: !banner?.[0]?.url })}
      ref={scrollContainerRef}
      id="container"
    >
      {/* 标题 */}
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {/* banner */}
      <section className={styles.banner}>{banner?.[0]?.url && <img src={banner?.[0]?.url} alt="banner" />}</section>
      {/* 内容 */}
      <div className={styles.containerWrap} style={{ marginTop: banner?.[0]?.url ? '-16px' : '0' }}>
        {/* 分类 */}
        {/* <section className={styles.tabs} ref={tabRef}>
          <div className={`${isFixed ? styles.fixed : ''}`}>
            <Tabs activeLineMode="fixed" style={TABSTYLE} onChange={handleTabChange} activeKey={activeKey}>
              {tabs.map((tab, i) => (
                <Tabs.Tab title={tab.title} key={`${i}`}></Tabs.Tab>
              ))}
            </Tabs>
          </div>
        </section> */}
        <div className={styles.content}>
          {tabs.map((tab, i) => (
            tab.__component === IGuideComponentType.Video &&
            <Element name={`${i}`} id={`${i}`} key={`${tab}`} className={styles.flexContent}>
                {(tab as IGuideVideo)?.listing?.map(video => (
                  <div key={video.id} className={styles.Grid} onClick={() => openVideoLink(video)}>
                    <div className={styles.videoContainer}>
                      {isYouTubeVideo(video.value || '') ? (
                        <Video
                          description={null}
                          key={video.id}
                          {...video}
                          language={guide?.locale || ''}
                          title={video.title}
                          sub_module={tab?.title}
                          art_id={video.id}
                          uid={uid}
                          module={'tutorial-catagory_page'}
                          style={{ width: '100%', height: '100%' }}
                        />
                      ) : (
                        <NativeVideo
                          description={null}
                          key={video.id}
                          {...video}
                          language={guide?.locale || ''}
                          title={video.title}
                          sub_module={tab?.title}
                          art_id={video.id}
                          uid={uid}
                          module={'tutorial-catagory_page'}
                          style={{ width: '100%', height: '100%' }}
                        />
                      )}
                    </div>
                    {/* <div className={styles.titleContainer}>
                      <div className={styles.titlePadding}>
                        <div className={styles.title}>{video.title}</div>
                      </div>
                    </div> */}
                  </div>
                ))}
            </Element>
          ))}
        </div>

        <div className={styles.content}>
          {tabs.map((tab, i) => (
            <Element name={`${i}`} id={`${i}`} key={`${i}`} className={styles.flexContent}>
              {tab.__component === IGuideComponentType.Article &&
                (tab as IGuideArticle)?.listing?.map(article => (
                  <div key={article.storeId} className={styles.cell} onClick={() => openLink(article)}>
                    <div className={styles.img}>{article?.image && <img src={article.image} alt="banner" />}</div>
                    <div className={styles.detail}>
                      <div className={styles.title}>{article.title}</div>
                      <div className={styles.time}>{moment(article?.updatedAt!).format('MMM, DD, YYYY')}</div>
                    </div>
                  </div>
                ))}
            </Element>
          ))}
        </div>
      </div>
    </div>
  )
}
export default CategoriesList
// end_ai_generated
